import './assets/sass/main.scss';

//
import {Fancybox} from "@fancyapps/ui";

window.Fancybox = Fancybox;

//
import tippy from 'tippy.js';

window.tippy = tippy;

//
import Vue from 'vue';

window.Vue = Vue;

//
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './locales';

//
import VueDummy from 'vue-dummy';

Vue.use(VueDummy);

//
import {VueSearchTrie} from "./plugins/VueSearchTrie/index.js";
import SearchMixins from "./mixins/SearchMixins";

Vue.use(VueSearchTrie);

//
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
    config: {id: "G-PXWPLX9RRF"}
});

//
import $ from "jquery";
// require("jquery-confirm");
import 'owl.carousel';

window.$ = window.jQuery = $;

//
Vue.config.productionTip = false;

//
Vue.prototype.$eventbus = window.$eventbus = new Vue({});

//
Vue.prototype.$application = window.$application;
Vue.prototype.$settings = window.$settings;

// Global Components
Vue.component('ArticleTitleHead', require('./components/ArticleTitleHead').default);
Vue.component('ArticleTitleTour', require('./components/ArticleTitleTour').default);
Vue.component('ArticleVerticalHead', require('./components/ArticleVerticalHead').default);
Vue.component('ArticleNote', require('./components/ArticleNote').default);
Vue.component('ImageWithDescriptions', require('./components/ImageWithDescriptions').default);
Vue.component('Paragraph', require('./components/Paragraph').default);
Vue.component('ParagraphFirstLetterBig', require('./components/ParagraphFirstLetterBig').default);
Vue.component('TimelineTitle', require('./components/TimelineTitle').default);


Vue.component('VerticalText', require('./components/VerticalText').default);
Vue.component('Paragraph', require('./components/Paragraph').default);
Vue.component('Triangles', require('./components/Triangles').default);
Vue.component('Dots', require('./components/Dots').default);
Vue.component('Square', require('./components/Square').default);
Vue.component('SectionVerticalTextParagpraphs', require('./components/SectionVerticalTextParagpraphs').default);
Vue.component('Author', require('./components/Author').default);

Vue.component('BtnSummary', require('./components/BtnSummary').default);
Vue.component('BtnDiaporama', require('./components/BtnDiaporama').default);
Vue.component('BtnSearch', require('./components/BtnSearch').default);

Vue.component('HotspotRichmedia', require('./components/HotspotRichmedia').default);
Vue.component('ModalRichmedia', require('./components/ModalRichmedia').default);

Vue.component('TimelineCarousel', require('./components/TimelineCarousel').default);
Vue.component('IconEdfMobile', require('./components/IconEdfMobile').default);

Vue.component('dynamic-link', {
    template: `
        <component v-bind:is="transformed"></component>`,
    data() {
        return {
            text: `<router-link to="${options.to}" v-html="${options.text}"></router-link>`
        }
    },

    props: {
        options: null,
    },
    computed: {
        transformed() {
            return {template: this.text}
        }
    }
});


new Vue({
    router,
    store,
    i18n,
    mixins: [SearchMixins],
    created() {
        const vm = this;
        vm.recoverKeywordsFromPages();

        // event google analitics
        vm.$eventbus.$on('gtag', function (options) {
            let defaultOptions = {
                method: 'event',
                action: 'event',
                params: {
                    event_category : 'general',
                    event_label : '',
                    value : '',
                },
            }

            defaultOptions = {
                ...defaultOptions,
                ...options
            };

            switch (defaultOptions.method) {
                case 'pageview':
                    vm.$gtag.pageview(defaultOptions.params.value);
                    break;
                case 'event':
                default:
                    vm.$gtag.event(defaultOptions.action, {
                        event_category: defaultOptions.params.event_category,
                        event_label: defaultOptions.params.event_label,
                        value: defaultOptions.params.value
                    }) ;
                    break;

            }

        })
    },
    render: function (h) {
        return h(App);
    }
}).$mount('#app');
